import { gql, useMutation } from "@apollo/client";

const UPDATE_ADMIN_USER_MUTATION = gql`
  mutation UpdateAdminUser(
    $_id: ID!
    $firstName: String
    $lastName: String
    $email: String
    $role: AdminRole
    $permissions: [AdminPermission!]
    $isActive: Boolean
  ) {
    updateAdminUser(
      _id: $_id
      firstName: $firstName
      lastName: $lastName
      email: $email
      role: $role
      permissions: $permissions
      isActive: $isActive
    ) {
      _id
      firstName
      lastName
      email
      role
      permissions
      isActive
      updatedAt
    }
  }
`;

export const useUpdateAdminUserMutation = () => {
  const [updateAdminUserMutation, { loading, error, data }] = useMutation(
    UPDATE_ADMIN_USER_MUTATION,
    {
      refetchQueries: ['GetAllAdminUsers'],
      awaitRefetchQueries: true,
    }
  );

  const updateAdminUser = async (variables: {
    _id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    role?: string;
    permissions?: string[];
    isActive?: boolean;
  }) => {
    try {
      const { data } = await updateAdminUserMutation({
        variables,
      });
      return data?.updateAdminUser;
    } catch (error) {
      console.error("Error updating admin user:", error);
      throw error;
    }
  };

  return { updateAdminUser, loading, error, data };
};






























